// extracted by mini-css-extract-plugin
export default {"img_icon":"TitleSVG_img_icon__M23I+","title_text":"TitleSVG_title_text__L565f","title_text_highlight":"TitleSVG_title_text_highlight__WyKGE"};